export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-aviatrix.vue?vue&type=template&id=5926bfdc"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-aviatrix.vue?vue&type=template&id=5926bfdc
// module id = xdyw
// module chunks = 0